import React from 'react';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'localization/useTranslation';

const useBreadcrumbs = (crumbs) => {
  const location = useLocation();
  const T = useTranslation();

  return _.map(crumbs, crumb => {
    if (_.isFunction(crumb.name)) {
      const Component = crumb.name;
      return { location: crumb.location, displayName: <Component params={crumb.params} search={location.search} /> };
    }
    return { location: crumb.location, displayName: T.localize(crumb.name) };
  });
};

export default useBreadcrumbs;
